<template>
  <div class="column">
    <div
      class="licence box large"
      style="height: 100%;"
    >
      <div class="info has-text-centered">
        <div style="">
          <span
            class="icon-static xl margin-bottom-sm"
            :class="product.name.toLowerCase()"
          />
          <h3 class="title-lowercase is-5 margin-bottom-sm">
            {{ product.name }}
          </h3>
          <h3
            class="title-lowercase is-3 margin-bottom-sm"
          >
            {{ product.amount|formattedDbAmount(product.currency.symbol, 0) }}
          </h3>
          <p
            class="text lg"
          >
            {{ product.description? product.description : "Sorry, but there is no description of this licence." }}
          </p>
        </div>
      </div>
      <button
        class="button is-small is-fullwidth has-icon-left"
        @click="handleAddToCartClick"
      >
        <span class="icon-button shopping-cart" />
        Add license to cart
      </button>
    </div>
  </div>
</template>

<script>
import { formatComponentName } from '@/utils/common.js'
import { logAddPaygToCart } from '@/utils/segment.js'

export default {
  name: 'LicenseSelectionModalItem',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  computed: {
    sortedProducts: function () {
      const products = [...this.$store.getters['cart/products']]
      return products.sort((a, b) => a.amount - b.amount)
    },

    artistTrackLabel: function () {
      const track = this.$store.getters['cart/trackAddingToCart']
      if (track) {
        return `${track.artist.name} - ${track.display_title}`
      }
      return ''
    },

    componentName: function () {
      return formatComponentName(this)
    }
  },

  methods: {
    handleAddToCartClick: function () {
      const selectedProduct = this.product

      this.$store.dispatch('cart/addToCart', selectedProduct)

      logAddPaygToCart()
    }
  }
}
</script>

<style lang="scss">
.licence {
  display: flex !important;
  flex-direction: column;
  .info {
    flex-grow: 1;
    margin-bottom: 24px;
  }
}
</style>
